import React from 'react';

export const name = 'filter';

export const Filter = () => (
  <svg
    viewBox="0 0 18 18"
    fill="none"
    color="#6C717C"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.75 4.5H2.25"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinejoin="bevel"
    />
    <path
      d="M15.75 4.5L8.25 4.5"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinejoin="bevel"
    />
    <path
      d="M6.75 3L6.75 6"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinejoin="bevel"
    />
    <path
      d="M15.75 9H13.5"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinejoin="bevel"
    />
    <path
      d="M12 9H2.25"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinejoin="bevel"
    />
    <path
      d="M12 7.5L12 10.5"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinejoin="bevel"
    />
    <path
      d="M3.75 13.5H2.25"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinejoin="bevel"
    />
    <path
      d="M15.75 13.5L5.25 13.5"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinejoin="bevel"
    />
    <path
      d="M3.75 12L3.75 15"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinejoin="bevel"
    />
  </svg>
);
